import { render } from "./updateimage.vue?vue&type=template&id=4d2b106d"
import script from "./updateimage.vue?vue&type=script&lang=js"
export * from "./updateimage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__